import { create } from 'zustand';

export const useDocumentRevisionStore = create((set) => ({
    revisions: [],
    activeRevision: null,
    selectedRevision: null,
    totalCount: 0,
    loading: false,
    error: null,
    uploading: false,

    setRevisions: (revisions) => set({ revisions }),
    setActiveRevision: (activeRevision) => set({ activeRevision }),
    setSelectedRevision: (revision) => set({ selectedRevision: revision }),
    clearSelectedRevision: () => set({ selectedRevision: null }),
    setLoading: (loading) => set({ loading }),
    setUploading: (uploading) => set({ uploading }),
    setError: (error) => set({ error }),
    clearStore: () => set({
        revisions: [],
        activeRevision: null,
        selectedRevision: null,
        totalCount: 0,
        error: null,
    }),
}));
